import type { Severity, ReviewStatus } from "../types";

export function SeverityBadge({ severity }: { severity: Severity }) {
  const styles: Record<Severity, string> = {
    Critical: "bg-[#7f1d1d]/10 text-[#7f1d1d]",
    High: "bg-danger-100 text-danger-600",
    "Medium-High": "bg-warn-100 text-[#a8641a]",
    Low: "bg-[#facc15]/15 text-[#854d0e]",
    None: "bg-section text-ink-muted",
    "None (Positive)": "bg-accent-50 text-accent-700",
  };
  return <span className={`badge ${styles[severity]}`}>{severity}</span>;
}

export function StatusBadge({ status }: { status: ReviewStatus }) {
  const styles: Record<ReviewStatus, string> = {
    "Closed - Positive": "bg-accent-500/10 text-accent-600",
    "Closed - Action done": "bg-accent-50 text-accent-700",
    "Open - Working in Progress": "bg-accent-100 text-accent-700",
    "Open - Review Required": "bg-warn-100 text-warn-500",
    "Open - Action Required": "bg-danger-500/10 text-danger-500",
  };
  return <span className={`badge ${styles[status]}`}>{status}</span>;
}

export function StarRating({ value }: { value: number }) {
  return (
    <span className="inline-flex items-center gap-0.5" aria-label={`${value} stars`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <span key={i} className={i < value ? "text-accent-600" : "text-border"}>
          ★
        </span>
      ))}
    </span>
  );
}

export function OverdueBadge() {
  return <span className="badge bg-danger-100 text-danger-600">Overdue</span>;
}
